import { convertISOToPhDate } from '~shared/lib/convert-date';

import { documentResourceToFormValues } from './document-resource-to-form-values';

import type { BusinessDocumentsFormValues } from '../../model/schemas';
import type { DocumentResource } from '../../model/types';

export function recoverBusinessDocuments(
  businessDocuments: DocumentResource[] | undefined
): BusinessDocumentsFormValues | undefined {
  if (!businessDocuments?.length) return undefined;

  const {
    BUSINESS_PERMIT,
    BIR_CERTIFICATE_OR_FORM2303,
    DTI_CERTIFICATE,
    OTHER,
  } = businessDocuments.reduce<{
    BUSINESS_PERMIT: DocumentResource[];
    BIR_CERTIFICATE_OR_FORM2303: DocumentResource[];
    DTI_CERTIFICATE: DocumentResource[];
    OTHER: DocumentResource[];
  }>(
    (acc, document) => {
      if (document.type === 'BUSINESS_PERMIT') {
        acc.BUSINESS_PERMIT.push(document);
        return acc;
      }
      if (document.type === 'BIR_CERTIFICATE_OR_FORM2303') {
        acc.BIR_CERTIFICATE_OR_FORM2303.push(document);
        return acc;
      }
      if (document.type === 'DTI_CERTIFICATE') {
        acc.DTI_CERTIFICATE.push(document);
        return acc;
      }
      if (document.type === 'OTHER') {
        acc.OTHER.push(document);
        return acc;
      }
      return acc;
    },
    {
      BUSINESS_PERMIT: [],
      BIR_CERTIFICATE_OR_FORM2303: [],
      DTI_CERTIFICATE: [],
      OTHER: [],
    }
  );

  return {
    BUSINESS_PERMIT: BUSINESS_PERMIT.map(documentResourceToFormValues),
    BIR_CERTIFICATE_OR_FORM2303: BIR_CERTIFICATE_OR_FORM2303.map(
      documentResourceToFormValues
    ),
    DTI_CERTIFICATE: DTI_CERTIFICATE.map(documentResourceToFormValues),
    dtiCertificateExpiryDate: DTI_CERTIFICATE[0]?.expiryDate
      ? convertISOToPhDate(DTI_CERTIFICATE[0].expiryDate)
      : '',
    OTHER: OTHER.map(documentResourceToFormValues),
  };
}
